/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!  注意  ！！！！！！！！！！！！！！！！！！！！！！！！
 * 由于SEO优化及统计需要  路由不能占用以下字段作为开头
 * 1.site
 * 2.baidu_verify_iCzfhrEepo
 *
 * */

import Vue from 'vue'
import Router from 'vue-router'
import request from '@/utils/request'
const Enter = () => import('../views/enter/index.vue')
const Home = () => import('../views/Home.vue')
const News = () => import('../views/news.vue')
const Atlas = () => import('../views/atlas.vue')
const Vdo = () => import('../views/vdo.vue')
const Library = () => import('../views/library.vue')
const Album = () => import('../views/album.vue')
const SpecialTopic = () => import('../views/SpecialTopic')
const Detail = () => import('../views/Detail')
const TagView = () => import('../views/tagView')
const ColumnView = () => import('../views/columnView')
const searchView = () => import('../views/searchView')
const loginView = () => import('../views/login.vue')
const registerView = () => import('../views/register.vue')
// const usermsgView = () => import('../views/UserMsg.vue')
const usermsgView = () => import('../views/passCard.vue')
const specialTopicDetailView = () => import('@/components/DetailComponents/SpecialTopicDetail.vue')
const albumDetailView = () => import('@/components/DetailComponents/albumDetail.vue')
const mulureadView = () => import('@/components/muluread/index.vue')
const allDatabaseView = () => import('@/views/allDatabase.vue')
const rootSearchView = () => import('@/views/rootSearch.vue')
const BookListView = () => import('@/views/BookList.vue')
const ArticlePageList = () => import('@/views/ArticlePageList.vue')
const TreeList = () => import('@/views/TreeList.vue')
const NodeList = () => import('@/views/NodeList.vue')
const BookImgList = () => import('@/views/BookImgList.vue')
const genealogyArticleList = () => import('@/views/genealogyArticleList.vue')
const sourceDetailView = () => import('@/views/sourceDetail.vue')
const wxloginView = () => import('@/views/components/wxlogin.vue')
const bindwxView = () => import('@/views/components/bindwx.vue')
const checkReadView = () => import('@/views/checkRead.vue')
const allDataSearchView = () => import('@/views/allDataSearch.vue')
const updateBindView = () => import('@/views/components/updateBind.vue')
const page404 = () => import('@/views/404.vue')
const page500 = () => import('@/views/500.vue')
const newLoginblack = () => import('@/views/components/newLoginblack.vue')
Vue.use(Router)
// 路由表
// 入口公用头部，尾部，重定向到首页
// 首页
// 资讯
// 图集
// 视频
// 文库
// 专辑
// 专题
// 详情
// 按标签查看
// 按栏目查看
// /搜索
// /登录
// /注册
export function createRouter() {
  return new Router({
    mode: 'history',
    routes: [
      { path: '/', redirect: { path: '/home' }, component: Enter, children: [
        { path: '/home', component: Home, name: 'ho' },
        { path: '/news/:templateId', component: News, name: 'ne' },
        { path: '/atlas/:templateId', component: Atlas, name: 'at' },
        { path: '/vdo/:templateId', component: Vdo, name: 'vd' },
        { path: '/library/:templateId', component: Library, name: 'li' },
        { path: '/album', component: Album, name: 'al' },
        { path: '/specialtopic', component: SpecialTopic, name: 'sp' },
        { path: '/Detail', component: Detail, name: 'dt' }, // /详情
        { path: '/tag/:tagName', component: TagView, name: 'tag' }, // //按照标签查看
        { path: '/column', component: ColumnView, name: 'column' }, // //按照栏目查看
        { path: '/search', component: searchView, name: 'search' }, // ///按搜索查看内容
        { path: '/login', component: loginView, name: 'lg' },
        { path: '/register', component: registerView, name: 'rg' },
        { path: '/user', component: usermsgView, name: 'um' },
        { path: '/albumDetail', component: albumDetailView, name: 'abd' }, // 专辑的详情
        { path: '/specialTopicDetail', component: specialTopicDetailView, name: 'std' }, // 专题的详情
        { path: '/albumDetailRead', component: mulureadView }, // 专题的详情阅读
        { path: '/database', component: allDatabaseView, name: 'datab' }, // 总数据库
        { path: '/rootsearch', component: rootSearchView, name: 'roots' }, // 根籍搜索
        { path: '/bookList', component: BookListView, name: 'Blist' }, // 谱书
        { path: '/treeList', component: TreeList, name: 'Trlist' }, // 谱系
        // { path: '/bookPageList', component: ArticlePageList, name: 'APlist' }, // 书页
        { path: '/nodeList', component: NodeList, name: 'Nlist' }, // 人物
        // { path: '/pictuerList', component: BookImgList, name: 'BIMGlist' }, // 页图
        { path: '/booktextList', component: genealogyArticleList, name: 'BWlist' }, // 谱文
        { path: '/sourceView', component: sourceDetailView, name: 'sourceView' }, // 资源类型的详情
        { path: '/wxlogin', component: wxloginView, name: 'wxloginHandel' },
        { path: '/bindwx', component: bindwxView, name: 'bindwxHandel' },
        { path: '/checkRead', component: checkReadView, name: 'crv' }, // ///查看权限
        { path: '/allDataSearch', component: allDataSearchView, name: 'asv' },
        { path: '/updateBind', component: updateBindView, name: 'updaewx' },
        { path: '/404', component: page404, name: '404' },
        { path: '/500', component: page500, name: '500' },
        { path: '/newLoginblack', component: newLoginblack, name: 'loginblack' }

      ] }
    ]
    // scrollBehavior(to, from, savedPosition) {
    //   return {
    //     x: 0,
    //     y: 0
    //   }
    // }
  })
}
